module.exports = __webpack_public_path__ + "static/img/6170_phase_function_Paper_PointsHejduk_Prediction.0f49d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6170_phase_function_Paper_PointsHejduk_Prediction.png
// module id = GTYX
// module chunks = 0